import React from "react";

function Config() {
  return (
    <React.StrictMode>
        <p>Config</p>
    </React.StrictMode>
  );
}

export default Config;
